// removed by extract-text-webpack-plugin
module.exports = {"Blueprints":"Blueprints--2RgUm","BlueprintList":"BlueprintList--2OZ4i","Create":"Create--TqjZz","CardFooter":"CardFooter--23OIe","Loading":"Loading--2LwpV"};